/** 백엔드 TicketStatus — 상태값이 기본값을 정한다 */
export const FEATURE_FLAG_STATUS = {
  IN_DEVELOPMENT: 'IN_DEVELOPMENT',
  READY_FOR_QA: 'READY_FOR_QA',
  READY_FOR_RELEASE: 'READY_FOR_RELEASE',
} as const;
export type FeatureFlagStatus = (typeof FEATURE_FLAG_STATUS)[keyof typeof FEATURE_FLAG_STATUS];

/** 이 admin 이 붙은 환경 — 값은 이 환경 DB 에만 저장된다 */
export type FeatureFlagEnvironment = 'local' | 'development' | 'production' | 'test';

/** 플래그 한 줄. 판정 = 상태값 기본값, 덮어쓴 값(dbEnabled)이 있으면 그 값 */
export interface FeatureFlagItem {
  /** 정규화한 티켓 키 (AMZBM122) — 바꾸기 · 지우기 경로와 이력 필터에 쓴다 */
  ticketKey: string;
  /** AMZBM-122 · 코드에 없는 키면 null */
  ticketNumber: string | null;
  status: FeatureFlagStatus | null;
  description: string | null;
  /** 덮어쓴 값이 없을 때 이 환경 판정 */
  defaultEnabled: boolean;
  /** 덮어쓴 값 · null 이면 기본값 따름 */
  dbEnabled: boolean | null;
  /** 이 환경의 실제 판정 */
  enabled: boolean;
  /** 개발 중이거나 코드에 없는 키 — 켜기 · 끄기 불가 */
  locked: boolean;
  inCode: boolean;
  memo: string | null;
  adminId: number | null;
  adminName: string | null;
  updateDate: string | null;
}

export interface FeatureFlagListResponse {
  /** 서버 NODE_ENV 그대로 — 위 넷 밖의 값이 올 수도 있다(화면은 경고로 보여 준다) */
  environment: FeatureFlagEnvironment | string;
  flags: FeatureFlagItem[];
}

export interface FeatureFlagUpdateRequest {
  /** 스위치 — 기본값과 같은 쪽이면 서버가 덮어쓴 값을 지운다 */
  enabled: boolean;
  /** 1~255자 필수 · 이력에 남는다 */
  reason: string;
  /** 덮어쓴 값에 붙는 메모. 보내지 않으면 그대로 · null 이면 지운다 */
  memo?: string | null;
}

export interface FeatureFlagUpdateResponse {
  flag: FeatureFlagItem;
  /** 알림을 받은 앱 인스턴스 수 · null 이면 알림 실패(저장은 됨 · 각 앱 재시작 필요) */
  notifiedInstances: number | null;
}

export interface FeatureFlagDeleteResponse {
  /** 코드에 없는 키를 지웠으면 null(목록에서 사라짐) */
  flag: FeatureFlagItem | null;
  notifiedInstances: number | null;
}

export interface FeatureFlagHistory {
  id: number;
  ticketKey: string;
  ticketNumber: string | null;
  /** 바꾸기 전 덮어쓴 값 · null 은 기본값 따름 */
  beforeEnabled: boolean | null;
  afterEnabled: boolean | null;
  reason: string;
  adminId: number | null;
  adminName: string | null;
  /** 알림 받은 앱 인스턴스 수 · null 은 알림 실패 */
  notifiedInstances: number | null;
  createDate: string;
}

export interface FeatureFlagHistoriesParams {
  ticketKey?: string;
  /** 한국시간 YYYY-MM-DD · 양끝 포함 */
  fromDate?: string;
  toDate?: string;
  page: number;
  /** 최대 100 */
  pageSize: number;
}

export interface FeatureFlagHistoriesResponse {
  data: FeatureFlagHistory[];
  total: number;
}
